import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import ReactGA from 'react-ga';
import { ThemeProvider } from 'styled-components';
import Media from 'react-media';

// Components
import AnalyticsTracker from './components/AnalyticsTracker';
import { Theme, Header, PageContainer, MainContent, StepBar } from './components';

import {
  DeliveryPage,
  InformationsPage,
  OrderPage,
  ThanksPage,
  TrainingPage,
  WelcomePage,
} from './pages';

// initialize Google Analytics
const debug = process.env.REACT_APP_ENV === 'local' || process.env.REACT_APP_ENV === 'staging';
ReactGA.initialize(process.env.REACT_APP_GA_IDENTIFIER, {
  debug,
  cookieDomain: debug ? 'null' : 'auto',
});
if (debug) {
  // Don't send any hit on local & staging environement
  ReactGA.ga('set', 'sendHitTask', null);
}

class Routes extends Component {
  render() {
    return (
      <ThemeProvider theme={Theme}>
        <React.Fragment>
          <Header />
          <MainContent>
            <PageContainer>
              {window.location.pathname !== '/' && (
                <Media query={{ maxWidth: Theme.breakpoints.md }}>
                  {matches => (matches ? null : <StepBar />)}
                </Media>
              )}
              {/* Google Analytics page tracker */}
              <Route component={AnalyticsTracker} />
              <Switch>
                <Route exact path="/" component={WelcomePage} />
                <Route path="/informations" component={InformationsPage} />
                <Route path="/order" component={OrderPage} />
                <Route path="/delivery" component={DeliveryPage} />
                <Route path="/training" component={TrainingPage} />
                <Route path="/thanks" component={ThanksPage} />
              </Switch>
            </PageContainer>
          </MainContent>
        </React.Fragment>
      </ThemeProvider>
    );
  }
}

// export default hot(module)(Routes);
export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js